(function(){
  if (window.__vcpInit) return; window.__vcpInit = true;
  var STORE_KEY = 'vc_provador_perfil_v2';
  var CANON = ['PP','P','M','G','GG'];

  // Tabela de medidas corporais (cm) que cada tamanho foi modelado para vestir.
  // Calibrada para bater com a referência de mercado (M ≈ busto 90-96 / cintura 76-84 / quadril 96-102).
  var GRADE = [
    {busto:[78,84],  cintura:[60,68],  quadril:[84,90]},   // PP
    {busto:[84,90],  cintura:[68,76],  quadril:[90,96]},   // P
    {busto:[90,96],  cintura:[76,84],  quadril:[96,102]},  // M
    {busto:[96,103], cintura:[84,92],  quadril:[102,109]}, // G
    {busto:[103,111],cintura:[92,101], quadril:[109,117]}  // GG
  ];

  function norm(s){ return (s||'').toString().trim().toUpperCase().replace(/\s+/g,''); }

  function clothingIndex(label){
    var u = norm(label);
    var map = {'PP':0,'XPP':0,'P':1,'PEQUENO':1,'S':1,'M':2,'MEDIO':2,'MÉDIO':2,'G':3,'GRANDE':3,'L':3,'GG':4,'XG':4,'XL':4,'XGG':5,'XXG':5,'XXL':5};
    if (map[u] !== undefined) return Math.min(4, map[u]);
    var n = parseInt(u,10);
    if (!isNaN(n)){ if(n<=36)return 0; if(n<=40)return 1; if(n<=42)return 2; if(n<=44)return 3; return 4; }
    return null;
  }

  // Estima busto / cintura / quadril (cm) a partir do perfil.
  // Quadril calibrado por 2 âncoras (62kg/165cm≈99, 80kg≈107); busto/WHR por formato do corpo.
  function estimateBody(p){
    var q = 0.45*p.peso + 0.20*(p.altura-165) + 71;
    var bustDelta = {ampulheta:-6, triangulo:-10, retangulo:-5, invertido:-1, oval:-4}[p.corpo];
    if (bustDelta===undefined) bustDelta = -6;
    var whr = {ampulheta:0.74, triangulo:0.72, retangulo:0.80, invertido:0.78, oval:0.85}[p.corpo] || 0.79;
    return { busto: q+bustDelta, cintura: q*whr, quadril: q };
  }

  // Recomenda o MENOR tamanho ofertado que não fica apertado em nenhuma região.
  // Uma única engine: a mesma comparação medidas×tabela gera recomendação E mapa de caimento
  // (nunca se contradizem). O caimento preferido move o limite de aperto tolerado.
  function recommendClothing(body, offered, caimento){
    // tolerância de "aperto" além do LIMITE SUPERIOR da faixa do tamanho (cm).
    // + = aceita mais justo (justo); − = exige mais folga (folgado).
    var tol = {justo:2, ideal:0, folgado:-4}[caimento];
    if (tol===undefined) tol = 0;
    var asc = offered.slice().sort(function(a,b){return a.idx-b.idx;});
    for (var i=0;i<asc.length;i++){
      var g = gradeFor(asc[i].size, asc[i].idx);
      var tight = Math.max(                    // região mais apertada: corpo acima do topo da faixa
        body.busto  - g.busto[1],
        body.cintura- g.cintura[1],
        body.quadril- g.quadril[1]
      );
      if (tight <= tol) return asc[i];          // menor tamanho que não aperta além do tolerado
    }
    return asc[asc.length-1]; // corpo maior que tudo -> maior tamanho
  }

  // Caimento de uma região: compara medida do corpo (u) com a faixa do tamanho.
  // d>0 => corpo maior que a peça => mais justo. Retorna nível -2..+2 e rótulo.
  function regionFit(u, range){
    var c = (range[0]+range[1])/2, half = (range[1]-range[0])/2;
    var d = u - c;                       // + = aperta, - = folga
    var pos = Math.max(0, Math.min(100, 50 - (d/(half+3.5))*50)); // 0=justo ... 100=folgado
    var lvl, txt;
    if (d >= half+3){ lvl=-2; txt='apertado'; }
    else if (d >= 1.6){ lvl=-1; txt='levemente justo'; }
    else if (d > -1.6){ lvl=0; txt='ideal'; }
    else if (d > -(half+3)){ lvl=1; txt='levemente folgado'; }
    else { lvl=2; txt='folgado'; }
    return { lvl:lvl, txt:txt, pos:pos };
  }

  // Grade por produto (metafield custom.provador_medidas) sobrepõe a grade genérica.
  var PGRADE = null; // { NORM(tamanho): {busto,cintura,quadril} } quando o produto tem tabela própria
  function setProductGrade(raw){
    PGRADE = null;
    if(!raw) return;
    try{
      var obj = (typeof raw==='string') ? JSON.parse(raw) : raw;
      var src = obj.tamanhos || obj; // aceita {tamanhos:{...}} ou {...} direto
      PGRADE = {};
      Object.keys(src).forEach(function(k){ PGRADE[norm(k)] = src[k]; });
    }catch(e){ PGRADE = null; }
  }
  function toRange(v){ return Array.isArray(v) ? [ +v[0], +v[1] ] : (typeof v==='number' ? [v-3, v+3] : (v!=null && !isNaN(+v) ? [+v-3, +v+3] : null)); }
  // Resolve a grade de um tamanho: tabela do produto (por rótulo) -> grade genérica (por índice).
  function gradeFor(label, idx){
    if(PGRADE){
      var e = PGRADE[norm(label)];
      if(e){ var b=toRange(e.busto), c=toRange(e.cintura), q=toRange(e.quadril);
        if(b&&c&&q) return {busto:b, cintura:c, quadril:q}; }
    }
    return GRADE[Math.max(0,Math.min(4,idx))];
  }
  function fitMapForSize(body, label, idx){
    var g = gradeFor(label, idx);
    return {
      busto:  regionFit(body.busto,  g.busto),
      cintura:regionFit(body.cintura,g.cintura),
      quadril:regionFit(body.quadril,g.quadril)
    };
  }
  // Veredito geral de um tamanho: 'serve' / 'ajuste' / 'evite'
  function sizeVerdict(fm){
    var lv=[fm.busto.lvl,fm.cintura.lvl,fm.quadril.lvl];
    var extreme = lv.filter(function(x){return Math.abs(x)===2;}).length;
    var mild = lv.filter(function(x){return Math.abs(x)===1;}).length;
    if (extreme>=1) return 'evite';
    if (mild>=2) return 'ajuste';
    return 'serve';
  }

  function shoeNumber(footCm, fit){
    var n = 2 * footCm - 11;
    if (fit === 'largo') n += 0.5;
    if (fit === 'justo') n -= 0.4;
    return n;
  }
  function pickShoe(sizes, target){
    var best=null,bestD=1e9;
    sizes.forEach(function(s){ var n=parseInt(norm(s),10); if(isNaN(n))return;
      var d=Math.abs(n-target); if(d<bestD){bestD=d;best={size:s,num:n,dist:d};} });
    return best;
  }

  function selectOnPage(root, optionName, sizeLabel){
    var selectors = root.querySelectorAll('.product-form__option-selector');
    var target=null;
    selectors.forEach(function(sel){
      var nm = sel.querySelector('.product-form__option-name');
      if(nm && nm.textContent.toLowerCase().indexOf(optionName.toLowerCase().split(' ')[0])>-1) target=sel;
    });
    if(!target) target = root;
    var want = norm(sizeLabel);
    var labels = target.querySelectorAll('.block-swatch__item, label, .product-form__option-value');
    for (var i=0;i<labels.length;i++){
      if (norm(labels[i].textContent) === want){
        var forId = labels[i].getAttribute && labels[i].getAttribute('for');
        var input = forId ? target.querySelector('#'+CSS.escape(forId)) : null;
        (input || labels[i]).click();
        return true;
      }
    }
    var select = target.querySelector('select');
    if (select){ for (var j=0;j<select.options.length;j++){ if(norm(select.options[j].textContent)===want){
      select.value = select.options[j].value; select.dispatchEvent(new Event('change',{bubbles:true})); return true; } } }
    return false;
  }

  // Localiza o <form> de compra do produto (o mais próximo do seletor usado).
  function findProductForm(){
    var root = currentCtx.root;
    var f = root && root.closest ? root.closest('form[action*="/cart/add"]') : null;
    if(f) return f;
    var sel = document.querySelector('.product-form__option-selector');
    if(sel && sel.closest){ f = sel.closest('form[action*="/cart/add"]'); if(f) return f; }
    return document.querySelector('form[action*="/cart/add"]');
  }

  // Descobre o variant id do tamanho selecionado (input[name=id] -> ?variant= -> radio numérico).
  function selectedVariantId(form){
    if(form){ var idi = form.querySelector('input[name="id"]'); if(idi && /^\d+$/.test(idi.value)) return idi.value; }
    var m = /[?&]variant=(\d+)/.exec(location.search); if(m) return m[1];
    var cr = document.querySelector('.product-form__option-selector input:checked'); if(cr && /^\d+$/.test(cr.value)) return cr.value;
    return null;
  }
  // Seleciona o tamanho e adiciona ao carrinho, indo direto pra /cart.
  function addToCart(size, dl){
    var ok = selectOnPage(currentCtx.root, currentCtx.sizeOption, size);
    pushDL('provador_add_carrinho', Object.assign({tamanho:size, selecionado:ok}, dl||{}));
    setTimeout(function(){                              // espera o tema atualizar o variant id
      var form = findProductForm();
      var vid = selectedVariantId(form);
      if(vid){
        fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:Number(vid), quantity:1}]})})
          .then(function(){ window.location.href='/cart'; })
          .catch(function(){ window.location.href='/cart'; });
      } else if(form){
        try{ HTMLFormElement.prototype.submit.call(form); }catch(e){ window.location.href='/cart'; }
      } else {
        window.location.href='/cart';
      }
    }, 300);
  }

  function buildModal(){
    var m = document.createElement('div');
    m.className = 'vcp-modal'; m.id = 'vcp-modal'; m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true');
    m.innerHTML = [
      '<div class="vcp-card" role="document">',
        '<div class="vcp-head"><div><h3>Provador Virtual</h3><p id="vcp-sub">Responda e descubra seu tamanho</p></div>',
          '<button class="vcp-close" data-vcp-close aria-label="Fechar">&times;</button></div>',
        '<div class="vcp-progress"><span id="vcp-bar"></span></div>',
        '<div class="vcp-body" id="vcp-body"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(m);
    m.addEventListener('click', function(e){ if(e.target===m) close(); });
    m.querySelector('[data-vcp-close]').addEventListener('click', close);
    return m;
  }

  var modal, currentCtx, state, stepIdx, steps;

  function close(){ if(modal){ modal.classList.remove('is-open'); document.documentElement.style.overflow=''; } }
  function open(ctx){
    currentCtx = ctx;
    setProductGrade(ctx.grade);
    if(!modal) modal = buildModal();
    state = loadProfile();
    stepIdx = 0;
    steps = ctx.isShoe ? shoeSteps() : clothingSteps();
    render();
    modal.classList.add('is-open');
    document.documentElement.style.overflow='hidden';
  }

  function loadProfile(){ try{ return JSON.parse(localStorage.getItem(STORE_KEY))||{}; }catch(e){ return {}; } }
  function saveProfile(){ try{ localStorage.setItem(STORE_KEY, JSON.stringify(state)); }catch(e){} }

  function optCard(field, val, emoji, lbl, sub){
    var sel = state[field]===val ? ' is-sel':'';
    return '<button type="button" class="vcp-opt'+sel+'" data-field="'+field+'" data-val="'+val+'">'+
      (emoji?'<span class="vcp-emoji">'+emoji+'</span>':'')+'<span class="vcp-lbl">'+lbl+'</span>'+
      (sub?'<span class="vcp-sub">'+sub+'</span>':'')+'</button>';
  }
  // Card de formato do corpo com a imagem real do manequim (a pessoa escolhe pela silhueta).
  function shapeCard(val, lbl){
    var sel = state.corpo===val ? ' is-sel':'';
    var url = (currentCtx.avatar && typeof currentCtx.avatar==='object' && currentCtx.avatar[val]) || '';
    var img = url ? '<img src="'+url+'" alt="" loading="lazy">' : '';
    return '<button type="button" class="vcp-opt vcp-shape'+sel+'" data-field="corpo" data-val="'+val+'">'+
      '<span class="vcp-shape-img">'+img+'</span><span class="vcp-lbl">'+lbl+'</span></button>';
  }

  function clothingSteps(){ return [
    {valid:function(){return state.altura>=130&&state.altura<=210&&state.peso>=35&&state.peso<=180;}, html:function(){return '<p class="vcp-q">Suas medidas</p><p class="vcp-hint">Base do cálculo — nada é enviado a servidor, fica só no seu navegador.</p>'+
      '<div class="vcp-field"><label>Altura</label><div class="vcp-inwrap"><input type="number" inputmode="numeric" data-input="altura" value="'+(state.altura||'')+'" placeholder="165"><span class="vcp-unit">cm</span></div></div>'+
      '<div class="vcp-field"><label>Peso</label><div class="vcp-inwrap"><input type="number" inputmode="numeric" data-input="peso" value="'+(state.peso||'')+'" placeholder="62"><span class="vcp-unit">kg</span></div></div>'+
      '<div class="vcp-field"><label>Idade <span style="color:#b3adbb">(opcional)</span></label><div class="vcp-inwrap"><input type="number" inputmode="numeric" data-input="idade" value="'+(state.idade||'')+'" placeholder="30"><span class="vcp-unit">anos</span></div></div>';}},
    {valid:function(){return !!state.corpo;}, html:function(){return '<p class="vcp-q">Formato do corpo</p><p class="vcp-hint">Toque na silhueta mais parecida com a sua</p><div class="vcp-shapes">'+
      shapeCard('ampulheta','Ampulheta')+
      shapeCard('triangulo','Triângulo')+
      shapeCard('invertido','Triâng. invertido')+
      shapeCard('retangulo','Retângulo')+
      shapeCard('oval','Oval')+'</div>';}},
    {valid:function(){return !!state.caimento;}, html:function(){return '<p class="vcp-q">Como você gosta da peça?</p><p class="vcp-hint">Preferência de caimento</p><div class="vcp-opts vcp-opts--3">'+
      optCard('caimento','justo','👗','Justo','marca o corpo')+
      optCard('caimento','ideal','✨','No corpo','caimento ideal')+
      optCard('caimento','folgado','🧥','Folgadinho','mais solto')+'</div>';}}
  ]; }

  function shoeSteps(){ return [
    {valid:function(){return state.pe>=18&&state.pe<=32;}, html:function(){return '<p class="vcp-q">Comprimento do pé</p><p class="vcp-hint">Pise numa folha, marque do calcanhar à ponta do dedão e meça em cm.</p>'+
      '<div class="vcp-field"><label>Comprimento do pé</label><div class="vcp-inwrap"><input type="number" inputmode="decimal" step="0.1" data-input="pe" value="'+(state.pe||'')+'" placeholder="24.5"><span class="vcp-unit">cm</span></div></div>';}},
    {valid:function(){return !!state.pefit;}, html:function(){return '<p class="vcp-q">Preferência de calce</p><div class="vcp-opts vcp-opts--3">'+
      optCard('pefit','justo','👠','Justo','')+
      optCard('pefit','ideal','👟','Ideal','')+
      optCard('pefit','largo','🥿','Folgado','')+'</div>';}}
  ]; }

  function render(){
    var body = document.getElementById('vcp-body');
    var bar = document.getElementById('vcp-bar');
    var sub = document.getElementById('vcp-sub');
    bar.style.width = ((stepIdx)/(steps.length)*100)+'%';
    sub.textContent = 'Passo '+(stepIdx+1)+' de '+steps.length;
    var step = steps[stepIdx];
    var isLast = stepIdx === steps.length-1;
    body.innerHTML = '<div class="vcp-step is-active">'+step.html()+
      '<div class="vcp-actions">'+
        (stepIdx>0?'<button class="vcp-btn vcp-btn--ghost" data-vcp-back>Voltar</button>':'')+
        '<button class="vcp-btn vcp-btn--primary" data-vcp-next disabled>'+(isLast?'Ver meu tamanho':'Continuar')+'</button>'+
      '</div></div>';

    body.querySelectorAll('input[data-input]').forEach(function(inp){
      inp.addEventListener('input', function(){ state[inp.dataset.input] = parseFloat(inp.value)||undefined; refreshNext(); });
    });
    body.querySelectorAll('.vcp-opt').forEach(function(op){
      op.addEventListener('click', function(){ state[op.dataset.field]=op.dataset.val;
        body.querySelectorAll('[data-field="'+op.dataset.field+'"]').forEach(function(x){x.classList.remove('is-sel');});
        op.classList.add('is-sel'); refreshNext(); });
    });
    var back = body.querySelector('[data-vcp-back]'); if(back) back.addEventListener('click', function(){ stepIdx--; render(); });
    body.querySelector('[data-vcp-next]').addEventListener('click', function(){
      saveProfile();
      if(isLast){ showResult(); } else { stepIdx++; render(); }
    });
    refreshNext();
  }

  function refreshNext(){
    var btn = document.querySelector('[data-vcp-next]'); if(!btn) return;
    btn.disabled = !steps[stepIdx].valid();
  }

  function rng(v){ return Math.round(v-2)+'–'+Math.round(v+2); }

  function showResult(){
    var body = document.getElementById('vcp-body');
    document.getElementById('vcp-bar').style.width='100%';
    document.getElementById('vcp-sub').textContent='Sua recomendação';
    var ctx = currentCtx;

    if(ctx.isShoe){
      var target = shoeNumber(state.pe, state.pefit);
      var pick = pickShoe(ctx.sizes, target);
      if(!pick){ body.innerHTML='<p class="vcp-q">Não foi possível recomendar</p><p class="vcp-hint">Este produto não usa numeração padrão.</p>'; return; }
      var conf = pick.dist<=0.4?'alta':(pick.dist<=0.9?'média':'baixa');
      body.innerHTML = analiseHTML('Calculando seu número…');
      afterAnalise(function(){
        body.innerHTML = shoeResultHTML(pick.size, conf);
        bindResultButtons({tamanho:pick.size, tipo:'calcado'});
      });
      pushDL('provador_recomendacao', {tamanho:pick.size, tipo:'calcado'});
      return;
    }

    // ROUPA — uma engine: medidas estimadas -> recomendação + mapa de caimento + explorador
    var body3 = estimateBody(state);
    var offered = ctx.sizes.map(function(s){return {size:s, idx:clothingIndex(s)};})
                    .filter(function(o){return o.idx!==null;})
                    .sort(function(a,b){return a.idx-b.idx;});
    if(!offered.length){ body.innerHTML='<p class="vcp-q">Não foi possível recomendar</p><p class="vcp-hint">Tamanhos deste produto fora do padrão PP–GG.</p>'; return; }
    var rec = recommendClothing(body3, offered, state.caimento);
    currentCtx._body = body3; currentCtx._offered = offered; currentCtx._rec = rec.size;
    body.innerHTML = analiseHTML('Analisando suas medidas…');
    afterAnalise(function(){
      body.innerHTML = clothingResultHTML(rec.size, body3, offered);
      animateKnobs(body);
      wireExplorer(rec.size);
      bindResultButtons({tamanho:rec.size, tipo:'roupa'});
    });
    pushDL('provador_recomendacao', {tamanho:rec.size, tipo:'roupa'});
  }

  // Executa o callback após o interstício de "análise" (respeita reduced-motion).
  function afterAnalise(cb){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(cb, reduce ? 120 : 820);
  }

  function fitRow(nome, r){
    var cls = r.lvl===0?'ok':(Math.abs(r.lvl)===1?'warn':'bad');
    return '<div class="vcp-fitrow"><span class="vcp-fitname">'+nome+'</span>'+
      '<span class="vcp-fitbar"><i class="vcp-knob vcp-'+cls+'" style="left:50%" data-pos="'+r.pos+'"></i></span>'+
      '<span class="vcp-fitlbl vcp-'+cls+'">'+r.txt+'</span></div>';
  }

  // Anima os knobs do centro (50%) até a posição real, para dar o efeito de "medindo".
  function animateKnobs(root){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.vcp-knob').forEach(function(k){
      var target = k.getAttribute('data-pos');
      if(reduce){ k.style.left = target+'%'; return; }
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ k.style.left = target+'%'; }); });
    });
  }

  function analiseHTML(msg){
    return '<div class="vcp-analise"><div class="vcp-spinner"></div><p>'+(msg||'Analisando suas medidas…')+'</p></div>';
  }

  // ---- Avatar: imagem de manequim + zonas de caimento (busto/cintura/quadril) sobrepostas ----
  // Posições verticais (% da altura da imagem) e larguras (% do container) calibradas p/ vcp-manequim.jpg.
  // Posição vertical das zonas (% da altura da imagem) POR FORMATO — medido em cada manequim.
  var ZPOS = {
    'default':  {busto:27, cintura:36, quadril:47},
    'ampulheta':{busto:33, cintura:45, quadril:56},
    'triangulo':{busto:29, cintura:39, quadril:52},
    'invertido':{busto:33, cintura:45, quadril:55},
    'retangulo':{busto:29, cintura:40, quadril:51},
    'oval':     {busto:30, cintura:41, quadril:51}
  };
  var ZW = {busto:34, cintura:27, quadril:38}; // larguras (% do container)
  function bandColor(lvl){ if(lvl===0) return '#8fce78'; if(Math.abs(lvl)===1) return '#e6b755'; return '#dd7f7f'; }
  // Escolhe a imagem de manequim conforme o formato do corpo respondido (fallback: default).
  function avatarUrl(){
    var a = currentCtx.avatar;
    if(!a) return '';
    if(typeof a === 'string') return a;
    return a[state.corpo] || a.default || '';
  }
  function figHTML(fm, url){
    if(!url) return '';
    var zp = ZPOS[state.corpo] || ZPOS['default'];
    function zone(reg){ return '<span class="vcp-zone" data-region="'+reg+'" style="top:'+zp[reg]+'%;width:'+ZW[reg]+'%;background:'+bandColor(fm[reg].lvl)+'"></span>'; }
    return '<div class="vcp-fig"><img class="vcp-figimg" src="'+url+'" alt="" loading="lazy">'+
      zone('busto')+zone('cintura')+zone('quadril')+'</div>';
  }
  function paintBands(root, fm){
    ['busto','cintura','quadril'].forEach(function(reg){
      var el=root.querySelector('.vcp-zone[data-region="'+reg+'"]');
      if(el) el.style.background = bandColor(fm[reg].lvl);
    });
  }

  function clothingResultHTML(size, body3, offered){
    var idx = clothingIndex(size);
    var fm = fitMapForSize(body3, size, idx);
    return '<div class="vcp-result">'+
      '<div class="vcp-badgewrap"><div class="vcp-badge"><span class="vcp-size" data-vcp-recsize>'+size+'</span><span class="vcp-size-lbl">melhor opção</span></div></div>'+
      '<div class="vcp-avatar">'+figHTML(fm, avatarUrl())+
        '<div class="vcp-avleg"><span><i style="background:#8fce78"></i>ideal</span><span><i style="background:#e6b755"></i>ajuste</span><span><i style="background:#dd7f7f"></i>justo/folgado</span></div>'+
      '</div>'+
      '<div class="vcp-measures"><p class="vcp-mtitle">Medidas corporais estimadas</p>'+
        '<div class="vcp-mgrid">'+
          '<div><b>'+rng(body3.busto)+'</b><span>busto (cm)</span></div>'+
          '<div><b>'+rng(body3.cintura)+'</b><span>cintura (cm)</span></div>'+
          '<div><b>'+rng(body3.quadril)+'</b><span>quadril (cm)</span></div>'+
        '</div></div>'+
      '<div class="vcp-fitmap" data-vcp-fitmap>'+
        '<p class="vcp-mtitle">Caimento no tamanho <b data-vcp-fitsize>'+size+'</b></p>'+
        fitRow('Busto', fm.busto)+ fitRow('Cintura', fm.cintura)+ fitRow('Quadril', fm.quadril)+
        '<div class="vcp-scale"><span>justo</span><span>ideal</span><span>folgado</span></div>'+
      '</div>'+
      '<div class="vcp-explore"><p class="vcp-mtitle">Prove também os tamanhos</p><div class="vcp-chips" data-vcp-chips>'+
        offered.map(function(o){ var isRec=norm(o.size)===norm(size);
          var v = isRec ? 'serve' : sizeVerdict(fitMapForSize(body3,o.size,o.idx));
          var mk = v==='serve'?'✓':(v==='ajuste'?'≈':'✕');
          return '<button type="button" class="vcp-chip vcp-v-'+v+(isRec?' is-rec':'')+'" data-size="'+o.size+'"><span class="vcp-chip-mk">'+mk+'</span>'+o.size+'</button>';
        }).join('')+'</div></div>'+
      '<div class="vcp-cta">'+
        '<button class="vcp-btn vcp-btn--primary" data-vcp-cart data-size="'+size+'">Adicionar ao carrinho · tam. <b data-vcp-applysize>'+size+'</b></button>'+
        '<button class="vcp-btn-text" data-vcp-keep data-size="'+size+'">Continuar olhando</button>'+
      '</div>'+
      '<button class="vcp-redo" data-vcp-redo>editar medidas</button>'+
      '<p class="vcp-foot">Estimativa a partir de altura, peso, formato do corpo e caimento — referência PP–GG. A modelagem varia por peça; use como guia.</p>'+
    '</div>';
  }

  function shoeResultHTML(size, conf){
    var confTxt = {alta:'Confiança alta', média:'Confiança média', baixa:'Ajuste fino recomendado'}[conf];
    return '<div class="vcp-result">'+
      '<div class="vcp-badgewrap"><div class="vcp-badge"><span class="vcp-size">'+size+'</span><span class="vcp-size-lbl">nº BR</span></div></div>'+
      '<h4 class="vcp-rh">Seu número ideal é '+size+'</h4>'+
      '<p class="vcp-conf"><b>'+confTxt+'</b></p>'+
      '<div class="vcp-cta">'+
        '<button class="vcp-btn vcp-btn--primary" data-vcp-cart data-size="'+size+'">Adicionar ao carrinho · tam. '+size+'</button>'+
        '<button class="vcp-btn-text" data-vcp-keep data-size="'+size+'">Continuar olhando</button>'+
      '</div>'+
      '<button class="vcp-redo" data-vcp-redo>refazer</button>'+
      '<p class="vcp-foot">Estimativa pelo comprimento do pé. Na dúvida entre dois números, prefira o maior.</p>'+
    '</div>';
  }

  function wireExplorer(recSize){
    var body = document.getElementById('vcp-body');
    var chips = body.querySelector('[data-vcp-chips]');
    if(!chips) return;
    chips.addEventListener('click', function(e){
      var c = e.target.closest('.vcp-chip'); if(!c) return;
      var size = c.dataset.size, idx = clothingIndex(size);
      var fm = fitMapForSize(currentCtx._body, size, idx);
      var map = body.querySelector('[data-vcp-fitmap]');
      map.querySelector('[data-vcp-fitsize]').textContent = size;
      var rows = map.querySelectorAll('.vcp-fitrow');
      var order=[fm.busto,fm.cintura,fm.quadril];
      rows.forEach(function(row,i){ var r=order[i];
        var cls=r.lvl===0?'ok':(Math.abs(r.lvl)===1?'warn':'bad');
        var knob=row.querySelector('.vcp-knob'); knob.style.left=r.pos+'%'; knob.className='vcp-knob vcp-'+cls;
        var lbl=row.querySelector('.vcp-fitlbl'); lbl.textContent=r.txt; lbl.className='vcp-fitlbl vcp-'+cls;
      });
      paintBands(body, fm);
      chips.querySelectorAll('.vcp-chip').forEach(function(x){x.classList.remove('is-active');});
      c.classList.add('is-active');
      var cart = body.querySelector('[data-vcp-cart]'); if(cart) cart.dataset.size = size;
      var keep = body.querySelector('[data-vcp-keep]'); if(keep) keep.dataset.size = size;
      var lbl = body.querySelector('[data-vcp-applysize]'); if(lbl) lbl.textContent = size;
      pushDL('provador_explorar_tamanho', {tamanho:size, veredito:sizeVerdict(fm)});
    });
  }

  function bindResultButtons(dl){
    var body = document.getElementById('vcp-body');
    // Principal: seleciona o tamanho + adiciona ao carrinho e vai direto pro carrinho.
    body.querySelector('[data-vcp-cart]').addEventListener('click', function(){
      addToCart(this.dataset.size, dl);
    });
    // Secundário (discreto): seleciona o tamanho e volta pra página do produto.
    var keep = body.querySelector('[data-vcp-keep]');
    if(keep) keep.addEventListener('click', function(){
      var ok = selectOnPage(currentCtx.root, currentCtx.sizeOption, this.dataset.size);
      pushDL('provador_continuar_olhando', Object.assign({selecionado:ok, tamanho:this.dataset.size}, dl));
      close();
    });
    var redo = body.querySelector('[data-vcp-redo]'); if(redo) redo.addEventListener('click', function(){ stepIdx=0; render(); });
  }

  function pushDL(ev, data){ try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:ev},data)); }catch(e){} }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-vcp-open]');
    if(!t) return;
    e.preventDefault();
    var wrap = t.closest('[data-vcp]');
    var cfg = {};
    try{ cfg = JSON.parse(wrap.querySelector('.vcp-config').textContent); }catch(err){}
    cfg.root = wrap.closest('.product-form, form, .product__info') || document;
    pushDL('provador_abrir', {tipo: cfg.isShoe?'calcado':'roupa'});
    open(cfg);
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
})();
